import { httpBackOfficeUtil } from './httpBackOfficeUtil'
import { ErrorCodes, createResult, createCommonResult } from './resultUtil'
import { getData } from '../../utils/common';
export const config = {
	getAppCfg,
	getLanguages,
	getDevices,
	getCustomFields,
	loadProductDependencies: loadProductDependencies,
	getProductDependencyRule: getProductDependencyRule,
	getProduct,
	getProductBySku,
	getProductPrices: getProductPrices
}

async function getAppCfg({
	app_id,
	use_cname = false,
	cname
} = {}) {
	try {
		var appId = await getData("APP_ID");
		if(!app_id) app_id = appId;
		
		var queryParams = {}
		if (use_cname) {
			queryParams.cloud_name = cname;
		}else {
			queryParams.platform_app_id = app_id;
		}
		let response = await httpBackOfficeUtil.get({
			resourcePath: '/v2/applications',
			queryParams: queryParams,
			logOutIfSessionInvalid: false,
            isBackend: false
		});
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception getAppCfg: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function getLanguages({ unauthorize = true }) {
	try {
		let response = await httpBackOfficeUtil.get({
			resourcePath: '/v2/languages',
			logOutIfSessionInvalid: false,
            isBackend: false
		});
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception getLanguages: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function getDevices({
	custom_fields,
	include_custom_fields = true,
	in_warehouse = true,
	product_id
},{}) {
	try {
		let response = await httpBackOfficeUtil.get({
			resourcePath: '/v2/devices',
			queryParams:{
				include_custom_fields,
				custom_fields,
				in_warehouse,
				product_id,
			},
            isBackend: true
		});
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception getDevices: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}
async function loadProductDependencies() {
	try {
		let response = await httpBackOfficeUtil.get({
			resourcePath: '/v2/products/dependency_rules',
            isBackend: true
		});
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception getDevices: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}
async function getProductDependencyRule(id) {
	try {
		let response = await httpBackOfficeUtil.get({
			resourcePath: `/v2/products/dependency_rules/${id}`,
            isBackend: true
		});
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception getDevices: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}
async function getProduct(id) {
	try {
		let response = await httpBackOfficeUtil.get({
			resourcePath: `/v2/products/${id}`,
            isBackend: true
		});
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception getDevices: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function getProductBySku({
    search_value
} = {}) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/products',
            queryParams: {
                search_value
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getProductBySku: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getProductPrices(productId) {
	try {
		let response = await httpBackOfficeUtil.get({
			resourcePath: `/v2/products/${productId}/prices`,
            isBackend: true
		});
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception getProductPices: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function getCustomFields({
    page = 1,
    size = 10,
    entity,
} = {},) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/custom_fields',
            queryParams: {
                page,
                size,
                entity,
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getCustomFields: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
